// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]
// 1、采购计划
// 2、采购入库
// 3、采购退货
// 4、处方发药
// 5、处方管理
// 6、处方退药
// 7、预警管理
// 8、库存管理
// 9、效期管理
// 10、追溯码管理

export default [
	{
		title: "采购计划",
		path: "/PSI/shopPlan",
		icon:'el-icon-s-home',
	},
	{
		title: "采购入库",
		path: "/PSI/shopStore",
		icon:'el-icon-s-platform',
		
	},
	{
		title: "采购退货",
		path: "/PSI/shopReturn",
		icon:'el-icon-s-check',
	},
	{
		title: "处方发药",
		path: "/PSI/shopDispensing",
		icon:'el-icon-s-shop',
	},
	{
		title: "处方管理",
		path: "/PSI/shopMangnier",
		icon:'el-icon-shopping-bag-1',
	},
	{
		title: "处方退药",
		path: "/PSI/shopBack",
		icon:'el-icon-s-platform',
		
	},
	{
		title: "预警管理",
		path: "/PSI/warnManger",
		icon:'el-icon-s-check',
	},
	{
		title: "药品库存",
		path: "/PSI/storeManger",
		icon:'el-icon-s-shop',
	},
	{
		title: "效期管理",
		path: "/PSI/periodManger",
		icon:'el-icon-shopping-bag-1',
	},
	{
		title: "追溯码管理",
		path: "/PSI/TraceabilityCode",
		icon:'el-icon-shopping-bag-1',
	},

]

